<template>
    <div id="modal-reports" class="modal">
        <button data-iziModal-close class="icon-close" style="top:unset!important;right: 10% !important">
            <svg><use xlink:href="#i_close"></use></svg>
            <span class="sr-only">{{ $t('close') }}</span>
        </button>
        <div class="reportsContainer">
            <svg class="i_event_tab"><use xlink:href="#i_event_tab"></use></svg>
            <h2>{{ $t('interestingPart') }}</h2>
            <h3>{{ $t('reportsTitle') }}</h3>
            <h4 style="color: #fff;">{{ $t('seatingImageHint') }}</h4>
            <ul>
                <li>
                    <a href="#" onclick="window.getReport('seating')">
                        <div class="iconWrap">
                            <svg class="seatingData"><use xlink:href="#i_users"></use></svg>
                        </div>
                        <div class="reportTxt">{{ $t('seating') }}</div>
                        <svg class="i_download"><use xlink:href="#i_download"></use></svg>
                    </a>
                </li>
                <li>
                    <a href="#" onclick="window.getReport('acceptations')">
                        <div class="iconWrap">
                            <svg class="arrivinigData"><use xlink:href="#i_users"></use></svg>
                        </div>
                        <div class="reportTxt">{{ $t('acceptations') }}</div>
                        <svg class="i_download"><use xlink:href="#i_download"></use></svg>
                    </a>
                </li>
                <li>
                    <a href="#" onclick="window.getReport('guests')">
                        <div class="iconWrap">
                            <svg class="guestData"><use xlink:href="#i_users"></use></svg>
                        </div>
                        <div class="reportTxt">{{ $t('guests') }}</div>
                        <svg class="i_download"><use xlink:href="#i_download"></use></svg>
                    </a>
                </li>
                <li>
                    <a href="#" onclick="window.getReport('attendance')">
                        <div class="iconWrap">
                            <svg class="guestArriveData"><use xlink:href="#i_users"></use></svg>
                        </div>
                        <div class="reportTxt">{{ $t('guestsAttendances') }}</div>
                        <svg class="i_download"><use xlink:href="#i_download"></use></svg>
                    </a>
                </li>
            </ul>
        </div>
        <div class="row text-center reportsLoader" style="display: none;">
            <rotate-loader style="opacity: .6" :color="'#132C43'"></rotate-loader>
        </div>
    </div>
</template>

<script>
    import RotateLoader from 'vue-spinner/src/RotateLoader.vue'
    export default {
        name: "ReportsModal",
        components:{
            RotateLoader
        },
        mounted(){
            let _this = this;

            window.reportsLoader = function(show = false){
                if(show){
                    $('.reportsContainer').hide();
                    $('.reportsLoader').show();
                }else{
                    $('.reportsContainer').show();
                    $('.reportsLoader').hide();
                }
            }

            window.getReport = function(type = 'seating'){
                let eventID = _this.$store.state.selectedEventID;
                if(_this.$store.state.user.type === 3) eventID = _this.$store.state.event.id;
                let report = '';
                window.reportsLoader(true);
                setTimeout(function(){
                    switch(type){
                        case 'seating':
                            _this.$store.dispatch('getEvent',eventID)
                                .then(response =>{
                                    //success
                                    let screenShot = response.data.presetScreenShot;
                                    if(screenShot != '' && screenShot > 0){
                                        window.downloadFile('https://' + _this.$store.state.app.domain + '/api/f.php?file=' + screenShot);
                                        window.reportsLoader();
                                    }else{
                                        _this.$swal({
                                            confirmButtonText:_this.$t('okButton'),
                                            type:'warning',
                                            title:_this.$t('noScreenShot'),
                                            timer:3000
                                        }).catch(_this.$swal.noop).then(()=>{
                                            window.reportsLoader();
                                        });
                                    }
                                })
                                .catch(err => {
                                    _this.$swal({
                                        confirmButtonText:_this.$t('okButton'),
                                        type:'error',
                                        title:_this.$t('fatalError'),
                                        timer:3000
                                    }).catch(_this.$swal.noop);
                                    window.reportsLoader();
                                })
                            break;

                        default:
                            _this.$store.dispatch('createReport',{event:eventID,type:type})
                                                    .then(response =>{
                                                        //success
                                                        window.downloadFile('https://' + _this.$store.state.app.domain + '/export/'+response.file);
                                                        window.reportsLoader();
                                                    })
                                                    .catch(err => {

                                                        _this.$swal({
                                                            confirmButtonText:_this.$t('okButton'),
                                                            type:'error',
                                                            title:_this.$t('fatalError'),
                                                            timer:3000
                                                        }).catch(_this.$swal.noop);
                                                        window.reportsLoader();
                                                    })
                            break;
                    }
                },500);
            }

        },
    }
</script>

<style scoped>
    h3{
        color: #293b5a;
        font-weight: 700;
        font-size:1.059rem;
    }
    .innerMainContent{
        padding:55px 45px;
        float: right;
        width:100%;
    }

    .h1Wrap .i_users{
        width:36px;
        height:28px;
    }
    .innerBox{
        padding:40px;
    }
    .innerBox h2{
        text-align: center;
        margin-bottom:40px;
    }
    .innerBox h2 span{
        color:#293b5a;
        font-weight: 700;
        font-size: 1.765rem;
        display: inline-block;
        vertical-align: middle;
    }
    .innerBox h2 svg{
        width: 22px;
        height: 22px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 5px;
        fill:#ff0000;
    }

    .owl-stage-outer{
        padding:50px 0;
    }
    .owl-carousel.owl-rtl .owl-item.active.center{
        transform: scale(1.2);
        box-shadow: 0px 1px 35px 0px rgba(0, 0, 0, 0.29);
        z-index: 1;
    }
    .imageWrap{
        border:1px solid #909090;
        position: relative;
    }
    .imageWrap .hoverEl{
        position: absolute;
        top:50%;
        right:50%;
        transform: translate(50%,-50%);
        width:62px;
        height:62px;
        background: #fff;
        border-radius: 50%;
        border:2px solid #7892c0;
    }
    .imageWrap .hoverEl svg{
        height:62px;
        width:32px;
        fill:#7892c0;
        display: block;
        margin:0 auto;
    }
    .owl-carousel{
        width:90%;
        margin:0 5%;
    }
    .owl-dots{
        text-align: center;
    }
    .owl-dot{
        display: inline-block;
        padding: 0 3px;
    }
    .owl-dot span{
        width:9px;
        height:9px;
        border-radius: 50%;
        display: block;
        background: #cdcdcd;
    }
    .owl-dot.active span{
        background: #7994c2;
    }
    .owl-next,
    .owl-prev{
        position: absolute;
        top:50%;
    }
    .owl-prev{
        transform: rotate(-90deg);
        right:-50px;

    }

    .owl-next{
        transform: rotate(90deg);
        left:-50px;

    }
    .owl-next svg,
    .owl-prev svg{
        width:29px;
        height:17px;
        fill:#7893c1;
    }
    .inviteBox{
        padding:0;
        margin-bottom:30px;
    }
    .inviteBox .textSide{
        width: 45%;
        float: right;
        text-align: right;
        padding: 15px;
    }
    .inviteBox .textSide h2{
        text-align: right;
        margin-bottom: 10px;
    }
    .inviteBox .imgSide{
        width: 55%;
        float: right;
        max-height: 210px;
        overflow: hidden;
    }
    .imgSide img{
        min-width: 100%;
    }
    .galleryBox{
        text-align: right;
        padding:15px;
    }
    .galleryBox h2{
        text-align: right;
        margin-bottom:10px;
    }
    .imgesWrapper{
        margin: 0 -7px;
        margin-top:45px;
    }
    .imgesWrapper div[class^="col-"]{
        padding:0 7px;
    }
    .imageItem{
        border:1px solid #d7d7d7;
        background: #f1f1f1;
        width:100%;
        height:90px;
        overflow: hidden;
        position: relative;
    }
    .imageItem img{
        width:100%;
    }
    .imageItem .hoverEl{
        position: absolute;
        top:100%;
        right:0;
        width:100%;
        height:100%;
        background: rgba(41,59,90,0.74);
        text-align: center;
        line-height: 90px;
        transition: top .25s ease-in-out;
        -moz-transition: top .25s ease-in-out;
        -webkit-transition: top .25s ease-in-out;
    }
    .imageItem:focus .hoverEl,
    .imageItem:hover .hoverEl{
        top:0;
        transition: top .25s ease-in-out;
        -moz-transition: top .25s ease-in-out;
        -webkit-transition: top .25s ease-in-out;
    }
    .imageItem .hoverEl button{
        display: inline-block;
    }
    .imageItem .hoverEl button.deleteImg svg{
        fill:#fff;
        width:19px;
        height:27px;
    }
    .imageItem .hoverEl button.ImgAction svg{
        fill:#fff;
        width:30px;
        height:27px;
    }

    .imageItem .fileInputWrap{
        width: 100%;
        height: 100%;
    }
    .imageItem .fileInputWrap input[type=file]{
        width: 100%;
        height: 100%;
    }
    .imageItem .fileInputWrap svg.i_files{
        height:90px;
        width:29px;
        top: 0;
        right: 50%;
        transform: translateX(50%);
    }
    #modal-reports.iziModal{
        text-align: center;
        background: transparent;
        box-shadow: none;
        max-width: unset!important;
    }
    #modal-reports.iziModal .iziModal-content{
        padding:0!important;
    }
    #modal-reports h2{
        color:#fff;
        font-size: 2.529rem;
    }
    #modal-reports h3{
        color:#fff;
        font-size: 1.353rem;
        margin-top: 15px;

    }
    #modal-reports .i_event_tab{
        width:76px;
        height:44px;
        fill:#fff;
        margin-bottom:20px;
    }
    #modal-reports ul{
        text-align: center;
        margin-top:80px;
    }
    #modal-reports ul li{
        display: inline-block;
        padding: 0 25px;
    }
    #modal-reports ul li a{
        display: block;
    }

    #modal-reports .iconWrap{
        width:116px;
        height:116px;
        border:2px solid #50c5bf;
        border-radius: 50%;
        margin:0 auto;
        background: transparent;
        transition: all .25s ease-in-out;
        -moz-transition: all .25s ease-in-out;
        -webkit-transition: all .25s ease-in-out;
    }

    #modal-reports .iconWrap svg{
        fill:#fff;
        height:112px;
    }
    #modal-reports .iconWrap svg.seatingData{width:31px;}
    #modal-reports .iconWrap svg.arrivinigData{width:40px;}
    #modal-reports .iconWrap svg.guestData{width:52px;}
    #modal-reports .iconWrap svg.guestArriveData{width:45px;}
    #modal-reports .reportTxt{
        font-size: 1.118rem;
        color:#fff;
        margin:10px 0;
    }
    #modal-reports .i_download{
        width: 20px;
        height:28px;
        fill:#fff;
    }
    #modal-reports ul li a:hover,
    #modal-reports ul li a:focus {
        text-decoration: none;
    }
    #modal-reports ul li a:hover .iconWrap,
    #modal-reports ul li a:focus .iconWrap{
        background: #273347;
        transition: all .25s ease-in-out;
        -moz-transition: all .25s ease-in-out;
        -webkit-transition: all .25s ease-in-out;
    }
    #modal-reports ul li a:hover .i_download,
    #modal-reports ul li a:focus .i_download{
        fill: #55ddd0;
        transition: all .25s ease-in-out;
        -moz-transition: all .25s ease-in-out;
        -webkit-transition: all .25s ease-in-out;
    }


    @media only screen and (max-width:1450px){
        .tabsWrap li a span{font-size: 1rem;}
        .tabsWrap li a svg{margin-left: 5px;}
    }
    .reportsLoader{
        padding-top: 50px;
    }
</style>
